// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pickyourviews {
    width: 100%;
    margin: 0;
    padding: 0 10px; /* Add padding to avoid content touching screen edges on small devices */
}

.pickyourviews-main {
    max-width: 1512px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; /* Center the containers */
    overflow: hidden;

}

.pickyourviews .intro {
    max-width: 1220px;
    color: var(--Border-primary, #000);
    font-size: 20px;
    font-weight: 400;
    line-height: 150%;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
    height: auto; /* Remove fixed height for better responsiveness */
    padding-bottom: 30px; /* Add spacing after intro */
    padding-top: 30px;
    text-align: left; /* Keep text aligned to the left */
}

.pickyourviews .care {
    width: 100%;
    max-width: 1220px;
    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
    background: linear-gradient(90deg, #458BEA 0%, #EC5372 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: left; /* Keep text aligned to the left */
    margin-bottom: 20px; /* Space below heading */
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 0px;
    display: flex; 
    flex-direction: column;
    justify-content: flex-start !important; /* Align content to the start (left) */
    align-items: flex-start !important; /* Align items to the start (left) */
}



.pickyourviews .issueselect {
    max-width: 1220px; /* Use 100% width of the container */
    width:100%;
    padding: 20px 10px; /* Reduce padding for smaller screens */
    padding-left: 30px;
    padding-right: 30px;
    flex-direction: column;
    align-items: center; /* Center align the content */
    gap: 10px;
    margin: 0 auto; /* Center the container itself */
}





.pickyourviews .similarreps {
    max-width: 100%; /* Use 100% width of the container */
    padding: 20px 10px; /* Reduce padding for smaller screens */
    padding-left: 30px;
    padding-right: 30px;
    flex-direction: column;
    align-items: center; /* Center align the content */
    gap: 10px;
    margin: 0 auto; /* Center the container itself */
}

.pickyourviews .issuegallery {
    max-width: 1220px; /* Use 100% width of the container */
    width: 100%;
    padding: 20px 10px; /* Reduce padding for smaller screens */
    padding-left: 30px;
    padding-right: 30px;
    flex-direction: column;
    align-items: center; /* Center align the content */
    gap: 10px;
    margin: 0 auto; /* Center the container itself */
}

.pickyourviews .login-message {
    text-align: center;
    margin: 20px auto;
    font-size: 18px;
    color: #333;
}

/* Add responsive text sizes */
@media (max-width: 768px) {
    .pickyourviews .intro {
        font-size: 18px;
    }

    .pickyourviews .care {
        font-size: 22px;
    }

    .pickyourviews .login-message {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PickYourViews/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,SAAS;IACT,eAAe,EAAE,wEAAwE;AAC7F;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAE,0BAA0B;IAC/C,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY,EAAE,kDAAkD;IAChE,oBAAoB,EAAE,4BAA4B;IAClD,iBAAiB;IACjB,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4DAA4D;IAC5D,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB,EAAE,kCAAkC;IACpD,mBAAmB,EAAE,wBAAwB;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sCAAsC,EAAE,sCAAsC;IAC9E,kCAAkC,EAAE,oCAAoC;AAC5E;;;;AAIA;IACI,iBAAiB,EAAE,oCAAoC;IACvD,UAAU;IACV,kBAAkB,EAAE,uCAAuC;IAC3D,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB,EAAE,6BAA6B;IAClD,SAAS;IACT,cAAc,EAAE,gCAAgC;AACpD;;;;;;AAMA;IACI,eAAe,EAAE,oCAAoC;IACrD,kBAAkB,EAAE,uCAAuC;IAC3D,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB,EAAE,6BAA6B;IAClD,SAAS;IACT,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,iBAAiB,EAAE,oCAAoC;IACvD,WAAW;IACX,kBAAkB,EAAE,uCAAuC;IAC3D,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB,EAAE,6BAA6B;IAClD,SAAS;IACT,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".pickyourviews {\n    width: 100%;\n    margin: 0;\n    padding: 0 10px; /* Add padding to avoid content touching screen edges on small devices */\n}\n\n.pickyourviews-main {\n    max-width: 1512px;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; /* Center the containers */\n    overflow: hidden;\n\n}\n\n.pickyourviews .intro {\n    max-width: 1220px;\n    color: var(--Border-primary, #000);\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 150%;\n    padding-left: 30px;\n    padding-right: 30px;\n    width: 100%;\n    height: auto; /* Remove fixed height for better responsiveness */\n    padding-bottom: 30px; /* Add spacing after intro */\n    padding-top: 30px;\n    text-align: left; /* Keep text aligned to the left */\n}\n\n.pickyourviews .care {\n    width: 100%;\n    max-width: 1220px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 140%;\n    background: linear-gradient(90deg, #458BEA 0%, #EC5372 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    text-align: left; /* Keep text aligned to the left */\n    margin-bottom: 20px; /* Space below heading */\n    padding-left: 30px;\n    padding-right: 30px;\n    margin-left: 0px;\n    display: flex; \n    flex-direction: column;\n    justify-content: flex-start !important; /* Align content to the start (left) */\n    align-items: flex-start !important; /* Align items to the start (left) */\n}\n\n\n\n.pickyourviews .issueselect {\n    max-width: 1220px; /* Use 100% width of the container */\n    width:100%;\n    padding: 20px 10px; /* Reduce padding for smaller screens */\n    padding-left: 30px;\n    padding-right: 30px;\n    flex-direction: column;\n    align-items: center; /* Center align the content */\n    gap: 10px;\n    margin: 0 auto; /* Center the container itself */\n}\n\n\n\n\n\n.pickyourviews .similarreps {\n    max-width: 100%; /* Use 100% width of the container */\n    padding: 20px 10px; /* Reduce padding for smaller screens */\n    padding-left: 30px;\n    padding-right: 30px;\n    flex-direction: column;\n    align-items: center; /* Center align the content */\n    gap: 10px;\n    margin: 0 auto; /* Center the container itself */\n}\n\n.pickyourviews .issuegallery {\n    max-width: 1220px; /* Use 100% width of the container */\n    width: 100%;\n    padding: 20px 10px; /* Reduce padding for smaller screens */\n    padding-left: 30px;\n    padding-right: 30px;\n    flex-direction: column;\n    align-items: center; /* Center align the content */\n    gap: 10px;\n    margin: 0 auto; /* Center the container itself */\n}\n\n.pickyourviews .login-message {\n    text-align: center;\n    margin: 20px auto;\n    font-size: 18px;\n    color: #333;\n}\n\n/* Add responsive text sizes */\n@media (max-width: 768px) {\n    .pickyourviews .intro {\n        font-size: 18px;\n    }\n\n    .pickyourviews .care {\n        font-size: 22px;\n    }\n\n    .pickyourviews .login-message {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
